import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent } from './button/button.component';
import { SelectComponent } from './select/select.component';
import { TextInputComponent } from './text-input/text-input.component';
import { TextareaComponent } from './textarea/textarea.component';
import { ColorPickerComponent } from './color-picker/color-picker.component';
import { AddButtonComponent } from './add-button/add-button.component';
import { ButtonSelectionGroup } from './button-selection-group/button-selection-group.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { ActionButtonComponent } from './action-button/action-button.component';
import { FileUploadAreaComponent } from './file-upload-area/file-upload-area.component';
import { TablerIconComponent } from 'angular-tabler-icons';
import { QuillTextareaComponent } from './quill-textarea/quill-textarea.component';
import { QuillEditorComponent } from 'ngx-quill';
import { NumberControlComponent } from './number-control/number-control.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { UploadButtonComponent } from './upload-button/upload-button.component';

@NgModule({
  declarations: [
    ButtonComponent,
    SelectComponent,
    TextInputComponent,
    TextareaComponent,
    ColorPickerComponent,
    AddButtonComponent,
    ButtonSelectionGroup,
    FileUploadComponent,
    ActionButtonComponent,
    FileUploadAreaComponent,
    QuillTextareaComponent,
    NumberControlComponent,
    CheckboxComponent,
    UploadButtonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    TablerIconComponent,
    QuillEditorComponent
  ],
  exports: [
    ButtonComponent,
    SelectComponent,
    TextInputComponent,
    TextareaComponent,
    ColorPickerComponent,
    AddButtonComponent,
    ButtonSelectionGroup,
    FileUploadComponent,
    ActionButtonComponent,
    FileUploadAreaComponent,
    QuillTextareaComponent,
    NumberControlComponent,
    CheckboxComponent,
    UploadButtonComponent
  ]
})
export class ControlsModule { }